/* template */
<template minapp="mpx" xlang="wxml"><div :style="[(customStyle)] | transRpxStyle" class="total-fee-wrap"><div class="total-fee-title"><div><span class="total-fee-left">总计</span><span class="total-fee-price-left">¥</span><span class="total-fee-price-right">{{personalPay}}</span></div><mpx-view @tap="click" class="total-fee-right">查看明细<es-icon name="angle-right" size="16" color="#666666"/></mpx-view></div><span class="order-text" v-if="(orderId)">订单号：{{orderId}}</span></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m58bb77da"}'>
  .total-fee-wrap
    background-color #ffffff
    padding 17px 12px
    border-radius 8px
  .total-fee
    &-title
      color #000000
      display flex
      justify-content space-between
    &-left
      font-family PingFangSC-Semibold
      font-size 16px
      font-weight 600
      margin-right 5px
    &-right
      font-size 12px
      display flex
      align-items center
      color #666666
    &-price-left
      font-family PingFangSC-Medium
      font-size 16px
      line-height 12px
      font-weight 600
      margin-right 2px
      color #FF6400
    &-price-right
      font-family Barlow Semi Condensed
      font-size 20px
      line-height 12px
      font-weight 400
      color #FF6400
  .order-text
    font-size 13px
    margin-top 4px
    color #999999
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m58bb77da"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./order-detail-total-fee-card.mpx.js?isComponent&outputPath=components%2Forder-detail-total-fee-card58bb77da%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./order-detail-total-fee-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Forder-detail-total-fee-card58bb77da%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m58bb77da"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/order-detail-total-fee-card58bb77da/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
